import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend';
import { ModulePackFE_HealthcareSpace, Preview_Expression, Preview_Variable, } from '@app/hcs-frontend';
class PgDev_Preview_Class extends ComponentSync {
    render() {
        return _jsxs(LL_H_C, { style: { padding: 16, gap: 16 }, children: [_jsx(Button, { variant: 'primary', onClick: () => Preview_Variable.show('35f333d8481bea7133eaac673be8c738'), children: "Variable - Chest Pain" }), _jsx(Button, { variant: 'primary', onClick: () => Preview_Variable.show('71550be03f7b50f0b898273ad0803ba0'), children: "Variable - HST I" }), _jsx(Button, { variant: 'primary', onClick: () => Preview_Expression.show('25f1896b530e7f3f1a477dbad74e7645'), children: "Expression - ADD-RS" })] });
    }
}
export const PgDev_Preview = {
    key: 'pg-dev-previews',
    name: 'KM2 Previews',
    renderer: PgDev_Preview_Class,
    group: 'HCSv2',
    modulesToAwait: [...ModulePackFE_HealthcareSpace],
};
